import React, {useState} from 'react';
import { Box, styled, useMediaQuery, useTheme} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { YtdReportColumns, YtdReportNonCandidateColumns } from '../../../types/referenceData/reportTableColumns';
import YtdReport from '../../../types/reports/ytdReport';

interface Props {
   tableRows?:YtdReport[];
   isCandidate: boolean;
}

const StyledDataGrid = styled(DataGrid)(() => ({
  '& .even-row': {
    backgroundColor: '#f9f9f9',
  },
  '& .odd-row': {
    backgroundColor: '#ffffff',
  },
}));

const YearToDateReportsTable = (props: Props): JSX.Element => {

    const [tableColumns, setColumns] = useState(props.isCandidate?YtdReportColumns:YtdReportNonCandidateColumns);
    const theme = useTheme(); 
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));
    const totalCount = props.tableRows?.length ?? 0;

    return (
        <Box 
        sx={{ 
        //display: 'flex', 
        //flexDirection: 'column',
        width: '95%',
        '.MuiDataGrid-columnHeaderTitle': { 
            fontWeight: 'bold !important',
        },
        }}>
        <StyledDataGrid
            rows={props.tableRows}
            //getRowHeight={() => 'auto'}
            getRowHeight={isSM? ()=> 'auto': () => 50}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
              ? 'even-row'
              : 'odd-row'
            }
            columns={tableColumns}
            getRowId={(row) => row.cpfId}
            disableColumnMenu
            disableRowSelectionOnClick
            hideFooterSelectedRowCount
            columnVisibilityModel={{
              cpfId: isSM?false:true,
              filerName: isSM?false:true,
              filerNameWithId: isSM?true:false,
            }}
            hideFooterPagination={totalCount < 100? true: false}
            sx={{ 
              '.MuiDataGrid-cell': {
                fontSize: isSM ? '0.875rem' : '1rem',
                whiteSpace: 'normal', 
                wordBreak: 'break-word',
                //paddingTop: '3px!important',
                //paddingBottom: '3px!important',
              },
            }}
        />
      </Box>
    );
}

export default YearToDateReportsTable;